module.exports = __webpack_public_path__ + "media/PAG73-06.1db7bf7f.mp3";